export var StockDisplayType;
(function (StockDisplayType) {
    StockDisplayType[StockDisplayType["List"] = 0] = "List";
    StockDisplayType[StockDisplayType["GroupByCells"] = 1] = "GroupByCells";
})(StockDisplayType || (StockDisplayType = {}));
